const LocationPin = () => (
  <svg className="location-pin" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.8549 8.57199C17.8549 13.6107 12.0234 18.0941 10.6446 19.0837C10.4554 19.2196 10.2306 19.2863 9.99777 19.2863C9.7649 19.2863 9.54014 19.2196 9.35095 19.0837C7.97215 18.0941 2.14062 13.6107 2.14062 8.57199C2.14062 4.2326 5.65838 0.714844 9.99777 0.714844C14.3372 0.714844 17.8549 4.2326 17.8549 8.57199Z"
      fill="#E2EDFB"
    />
    <path
      d="M7.14062 7.85714C7.14062 8.6149 7.44164 9.34163 7.97746 9.87745C8.51328 10.4133 9.24001 10.7143 9.99777 10.7143C10.7555 10.7143 11.4823 10.4133 12.0181 9.87745C12.5539 9.34163 12.8549 8.6149 12.8549 7.85714C12.8549 7.09938 12.5539 6.37266 12.0181 5.83684C11.4823 5.30102 10.7555 5 9.99777 5C9.24001 5 8.51328 5.30102 7.97746 5.83684C7.44164 6.37266 7.14063 7.09938 7.14062 7.85714Z"
      fill="white"
    />
    <path
      d="M17.8549 8.57199C17.8549 13.6107 12.0234 18.0941 10.6446 19.0837C10.4554 19.2196 10.2306 19.2863 9.99777 19.2863C9.7649 19.2863 9.54014 19.2196 9.35095 19.0837C7.97215 18.0941 2.14062 13.6107 2.14062 8.57199C2.14062 4.2326 5.65838 0.714844 9.99777 0.714844C14.3372 0.714844 17.8549 4.2326 17.8549 8.57199Z"
      stroke="#002EE3"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.14062 7.85714C7.14062 8.6149 7.44164 9.34163 7.97746 9.87745C8.51328 10.4133 9.24001 10.7143 9.99777 10.7143C10.7555 10.7143 11.4823 10.4133 12.0181 9.87745C12.5539 9.34163 12.8549 8.6149 12.8549 7.85714C12.8549 7.09938 12.5539 6.37266 12.0181 5.83684C11.4823 5.30102 10.7555 5 9.99777 5C9.24001 5 8.51328 5.30102 7.97746 5.83684C7.44164 6.37266 7.14063 7.09938 7.14062 7.85714Z"
      stroke="#002EE3"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function PropertyCard({ property }) {
  return (
    <div className="property-card">
      <div className="property-img-wrap">
        <img src={property.image} alt={property.name} className="property-img" />
        {property.reraRegistered && <span className="rera-badge">RERA Registered</span>}
      </div>

      <div className="property-info">
        <div>
          <h3 className="property-name large-body bold">{property.name}</h3>
          <p className="property-developer small-body">{property.developer}</p>
        </div>

        <div className="property-meta">
          <div className="property-meta-row">
            <LocationPin />
            <span className="small-body">{property.location}</span>
          </div>
          {/* <div className="property-meta-row">
            <LocationPin />
            <span className="small-body">{property.bhk}</span>
          </div>
          <div className="property-meta-row">
            <LocationPin />
            <span className="small-body">{property.propertyType}</span>
          </div>
          <div className="property-meta-row">
            <LocationPin />
            <span className="small-body">{property.status}</span>
          </div> */}
        </div>

        {/* <div className="property-price-row">
          <p className="property-price small-body">
            Starting from <strong>{property.price}</strong>
          </p>
        </div> */}
      </div>
    </div>
  );
}
